import { Inkasso } from '@o30/entities';
import { Comparator } from '../comparator';
import { compareAdresseById } from './adresse-comparator';
import { compareBankverbindungByIndex } from './bankverbindung-comparator';
import { compareObjektBase } from './objektbase-comparator';

/*,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-^"-.,.-"^"-.,.-"^"-.,.-"^*
|       /\                                                                       /\       |
|      /  \                this is a generated file, do not edit                /  \      |
|      |  |                                                                     |  |      |
|      |  |                see comparator.info for entity version               |  |      |
|     / == \               by ComparatorGenerator (O30 Entities)               / == \     |
|     |/**\|                                                                   |/**\|     |
\*,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-^"-.,.-"^"-.,.-"^"-.,.-"*/

export const compareInkasso: (backup: Inkasso, data: Inkasso) => { [P in keyof Inkasso]?: Inkasso[P] } = (backup, data) => {
  let key: keyof Inkasso;
  const diff: Partial<Inkasso> = {};
  const comparator = new InkassoComparator();

  key = 'adresse';
  comparator.addDiff(diff, key,
    comparator.compareFieldProperty(backup ? backup[key] : null, data[key], compareAdresseById));

  key = 'bankverbindung';
  comparator.addDiff(diff, key,
    comparator.compareFieldProperty(backup ? backup[key] : null, data[key], compareBankverbindungByIndex));

  key = 'beitragszahler';
  comparator.addDiff(diff, key,
    comparator.compareFieldProperty(backup ? backup[key] : null, data[key], compareObjektBase));
  return comparator.compare(backup, data, diff);
};

export class InkassoComparator extends Comparator<Inkasso> {
  public static readonly IDS: (keyof Inkasso)[] = [];
  public static readonly PROPERTIES: (keyof Inkasso)[] = [];
  public static readonly FIELDPROPERTIES: (keyof Inkasso)[] = [
    'externerSchluessel',
    'kundenKonto',
    'zahlweg'
  ];
  public static readonly KEYVALUEFIELDPROPERTIES: (keyof Inkasso)[] = [
    'zahlungsart'
  ];
  public static readonly KEYVALUELISTFIELDPROPERTIES: (keyof Inkasso)[] = [];
  public static readonly OBJECTPROPERTIES: (keyof Inkasso)[] = [
    'adresse',
    'bankverbindung',
    'beitragszahler'
  ];
  public static readonly IGNOREDPROPERTIES: (keyof Inkasso)[] = [
    'editable',
    'externerSchluesselAnzeigen',
    'kundenKontoName'
  ];

  /**
   * makes sure all properties are handled by the comparator
   * if there is an error, you might need to re-run ComparatorGenerator
   */
  public getTestMock(): Inkasso {
    return {
      adresse:                    null,
      bankverbindung:             null,
      beitragszahler:             null,
      editable:                   null,
      externerSchluessel:         null,
      externerSchluesselAnzeigen: null,
      kundenKonto:                null,
      kundenKontoName:            null,
      zahlungsart:                null,
      zahlweg:                    null
    };
  }

  public getIds() {
    return InkassoComparator.IDS;
  }

  public getProperties() {
    return InkassoComparator.PROPERTIES;
  }

  public getFieldProperties() {
    return InkassoComparator.FIELDPROPERTIES;
  }

  public getKeyValueFieldProperties() {
    return InkassoComparator.KEYVALUEFIELDPROPERTIES;
  }

  public getKeyValueListFieldProperties() {
    return InkassoComparator.KEYVALUELISTFIELDPROPERTIES;
  }

  public getObjectProperties() {
    return InkassoComparator.OBJECTPROPERTIES;
  }

  public getIgnoredProperties() {
    return InkassoComparator.IGNOREDPROPERTIES;
  }

}
